import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';

export const Container = styled.div`
  border-bottom: 1px solid ${colours.BLACK};
  grid-area: keyLinks;
  padding: ${spacing.M} 0;
`;

export const ImageContainer = styled.div`
  border: 1px solid ${colours.BLACK};
  border-radius: 50%;
  cursor: pointer;
  display: grid;
  flex-shrink: 0;
  height: 44px;
  place-items: center;
  width: 44px;
`;

export const KeyLinks = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${spacing.S};
  margin: 0;
  padding: 0;

  @media ${media.greaterThan('lg')} {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: ${spacing.M};
  }

  @media ${media.greaterThan('xl')} {
    gap: ${spacing.XXL};
  }
`;

export const KeyLink = styled.li<{ $hide?: boolean }>`
  cursor: pointer;
  display: ${({ $hide }) => ($hide ? 'none' : 'flex')};

  & a {
    color: ${colours.BLACK};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
`;

export const KeyLinkContainerWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  gap: ${spacing.S};

  &:hover,
  &:focus {
    .keylink-icon {
      background-color: ${colours.LIGHT_BLUE};
    }
  }
`;

export const KeyLinkTitle = styled.span`
  ${TypographyStyles.Body.Tiny.SemiBold}
`;

export const KeyLinkDescription = styled.p`
  ${TypographyStyles.Body.Tiny.Regular}
  margin: ${spacing.XXXXS} 0;
`;
